export class ContactFormModel {
    firstName: string;
    lastName: string;
    emailAddress: string;
    phoneNumber: string;
    feedback: string;
}
